import React from 'react';
import { Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/components/ui/use-toast';
import { PhoneNumberDisplay } from './phone-number-display';

interface PhoneNumberCopyProps {
  phoneNumber: string;
  className?: string;
  showCopyButton?: boolean;
}

export const PhoneNumberCopy: React.FC<PhoneNumberCopyProps> = ({
  phoneNumber,
  className = '',
  showCopyButton = true,
}) => {
  const { toast } = useToast();

  const handleCopy = () => {
    navigator.clipboard.writeText(phoneNumber);
    toast({
      title: "Copied",
      description: "Phone number copied to clipboard",
    });
  };

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <PhoneNumberDisplay phoneNumber={phoneNumber} />
      {showCopyButton && (
        <Button
          variant="ghost"
          size="icon"
          className="h-6 w-6"
          onClick={handleCopy}
          title="Copy phone number"
        >
          <Copy className="h-3 w-3" />
        </Button>
      )}
    </div>
  );
};